import { DEFAULT_LAYOUT } from '@/router/constant'
import type { RouteRecordRaw } from 'vue-router'

const folderInfo: RouteRecordRaw = {
  path: '/folder',
  name: 'Folder',
  component: DEFAULT_LAYOUT,
  redirect: '/folder/folderInfo',

  children: [
    {
      path: 'folderInfo',
      name: 'FolderInfo',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/folderInfo/IndexView.vue'),
      meta: { title: 'フォルダ一覧', requiresAuth: false },
    },
  ],
}

export default folderInfo
